module.exports = __webpack_public_path__ + "img/yom_huledet_yes.60208925.png";